import FullTeam from '../Views/Company/FullTeam'
import TeamHero from '../Views/Company/TeamHero'
import Partners from '../Views/Home/Partners'
import { teamMembers } from './teamMembers'
import { partnerTiles } from './partnerTiles'

const company = [
  {
    key: 'teamHero',
    component: TeamHero,
    color: 'LIGHT',
    shadow: true,
    main: {
      h: 'Our Company',
      p: [
        'Our team is made up of developers, designers, and geospatial experts. We are based out of the New Lab at the Brooklyn Navy Yard, an interdisciplinary workspace designed to support urban entrepreneurs leveraging advanced technologies.'
      ],
      // cta: {
      //   path: 'https://jobs.lever.co/foam',
      //   text: 'We are currently hiring',
      //   type: 'EXTERNAL'
      // },
      justification: 'LEFT',
      width: 'NARROW'
    },
    img: { src: '/publicAssets/newlab.jpg', alt: '' }
  },
  {
    key: 'company',
    component: FullTeam,
    color: 'LIGHT',
    main: null,
    // {
    //   h: 'Our Full Team',
    //   p:
    //     'We are designing a shared spatial language for open decentralized systems and smart contracts. FOAM is working on geospatial protocol and the resulting market implications on global infrastructures.',
    //   icn: { src: '/publicAssets/icons/team.png', alt: '' },
    //   justification: 'CENTER',
    //   width: 'WIDE'
    // },
    teamMembers
  },
  {
    key: 'partners',
    component: Partners,
    color: 'DARK',
    partnerTiles
  }
]

export { company }



// WEBPACK FOOTER //
// ./src/content/companyPage.js